import React from 'react'

export default function RTIDTrainingManual() {
    return <div>RTID Training Manual</div>
}
